import { NEW_LANDINGI_URL } from '@config/env'
import { openWindowWithJWT } from '@helpers/semrush'
import { Alert, Button } from '@landingi/landingi-ui-kit'
import styles from '@pages/Pricing/routes/AccountPackage/components/PlanPanels/components/SummarySubscriptionModal/SummarySubscriptionModal.module.scss'
import { Trans } from 'react-i18next'
import { Row } from 'simple-flexbox'

export const UpgradePlanAlert = ({ date }: { date: string }) => (
  <Alert oneSideMessagePadding>
    <Trans i18nKey='change.plan.page.upgrade.plan.alert' values={{ date }} />
  </Alert>
)

export const DowngradeFromAgencyAlert = ({
  subaccountsCount
}: {
  subaccountsCount: number
}) => {
  const handleOpenSubaccounts = () =>
    openWindowWithJWT(`https://${NEW_LANDINGI_URL}/agency/accounts`)

  return (
    <Alert type='alert' oneSideMessagePadding>
      <Row justifyContent='space-between' alignItems='center'>
        <div className={styles['downgrade-from-agency-alert-text']}>
          <Trans
            i18nKey='change.plan.page.downgrade.from.agency.plan.alert'
            values={{ count: subaccountsCount }}
          />
        </div>

        <Button onClick={handleOpenSubaccounts} size='tiny'>
          <Trans i18nKey='change.plan.page.go.to.subaccount' />
        </Button>
      </Row>
    </Alert>
  )
}

export const ChangePlanWithAddons = () => (
  <Alert type='warning' oneSideMessagePadding>
    <Trans i18nKey='change.plan.page.change.plan.with.addons' />
  </Alert>
)

export const AddonsLimitExceededAlert = ({
  packageName
}: {
  packageName: string
}) => (
  <Alert type='warning' oneSideMessagePadding>
    <Trans
      i18nKey='change.plan.page.change.plan.with.limit.exceeded'
      values={{ packageName }}
    />
  </Alert>
)
